import { useRef } from "react";
import { useZxing } from "react-zxing";
import { toast } from "react-toastify";
import XIcon from "../icons/XIcon.js";
import "../styles/SingleBarcodeScanner.css";

function SingleBarcodeScanner({ onDetected, onClose }) {
  const detectedRef = useRef(false);
  const errorNotifiedRef = useRef(false);

  const { ref } = useZxing({
    formats: ["linear_codes"],
    constraints: {
      video: {
        facingMode: { ideal: "environment" },
      },
      audio: false,
    },
    trySkew: true,
    timeBetweenDecodingAttempts: 200,
    onDecodeResult(result) {
      if (detectedRef.current) return;

      const barcodeValue = String(result?.rawValue || "").trim();
      if (barcodeValue) {
        detectedRef.current = true;
        onDetected(barcodeValue);
      }
    },
    onError() {
      if (errorNotifiedRef.current) return;
      errorNotifiedRef.current = true;
      toast.error("Unable to open camera for barcode scanning.");
    },
  });

  return (
    <div className="single-barcode-scanner-overlay">
      <div className="single-barcode-scanner-modal">
        <button
          type="button"
          className="single-barcode-scanner-close"
          onClick={onClose}
          aria-label="Close barcode scanner"
        >
          <XIcon />
        </button>
        <video
          ref={ref}
          className="single-barcode-scanner-video"
          muted
          playsInline
        />
        <div className="single-barcode-scanner-frame" />
      </div>
    </div>
  );
}

export default SingleBarcodeScanner;
